export const formatMoney = (value: string, trunc = false) => {
  if (!value) return ''
  let isNegative = false;

  if (!trunc) {
    value = value+'';
    if (value.includes("-")) {
      isNegative = true;
    }
    value = value.replace(/[^0-9-]+/g, '');
    value = value.replace(/-/g, '');
    value = `${isNegative ? "-" : ""}$${value.replace(/([0-9]{2})$/g, '.$1')}`
    if (value.length > 6) value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return value
  } else {
    value = value+'';
    if (value.includes("-")) {
      isNegative = true;
    }
    value = value.replace(/[^0-9.]+/g, '');
    value = value.replace(/-/g, '');
    value = value.replace(/\..*/g, "");
    if (value.length > 3) value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    return `${isNegative ? "-" : ""}$${value}`
  }
}

export const formatNumber = (value: string) => {
  return value.toString().replace(/[^0-9.-]+/g, '');
}

export const formatMoneyWithZero = (value: string) => {
  if(!value) return '0'
    // Convert to string and remove any non-numeric characters except decimal point
    value = value.toString().replace(/[^0-9.-]+/g, '');
    
    // Split into whole and decimal parts
    const [whole, decimal] = value.split('.');
    
    // Format the whole number part with commas
    const formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    
    // If there's a decimal part, add it back
    const result = decimal ? `$ ${formattedWhole}.${decimal.slice(0, 2)}` : `$ ${formattedWhole}`;
    
    return result;
}

export const formatMoneyHeatmap = (value: number | null, isMobile = false) => {
  if(value === 0) return isMobile? '$0' : '$0'
  if (!value) return ''
 
  value = Math.round(value);
  
  if (isMobile) return ''

  
  return `$${value}`
}

    // Utility function to format the number as a currency with K, M notation
export function formatCurrency(value: number): string {
      if (value >= 1_000_000) {
          return `$${(value / 1_000_000).toFixed(2)}M`;
      } else if (value >= 1_000) {
          return `$${(value / 1_000).toFixed(0)}K`;
      } else {
          // Fallback to the default currency format for values less than 1,000
          return new Intl.NumberFormat('en-US', { 
              style: 'currency', 
              currency: 'USD', 
              minimumFractionDigits: 1,
              maximumFractionDigits: 1 
          }).format(value);
      }
  }

  export const date2usDotDateTime = (date: string) => {
    const dateObj = new Date(date);
    const timezoneOffset = dateObj.getTimezoneOffset() * 60000; // Convert offset to milliseconds
    dateObj.setTime(dateObj.getTime() - timezoneOffset); // Subtract offset to get local time
    const time = dateObj.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }).toLowerCase();
    const datePart = dateObj.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' }).replace(/\//g, '.');
    return `${datePart} @ ${time}`;
    // return `${datePart}`;
  }

  /*
  export const date2usSlashDateTime = (date: string) => {
    const dateObj = new Date(date);
    const timezoneOffset = dateObj.getTimezoneOffset() * 60000; // Convert offset to milliseconds
    dateObj.setTime(dateObj.getTime() - timezoneOffset); // Subtract offset to get local time
    const time = dateObj.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }).toLowerCase();
    const datePart = dateObj.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' });
    return `${datePart} @ ${time}`;    
  }
  */

export const date2usSlashDateTime = (date: string, timezone?: string) => {
  console.log("date:", date);

  const normalizeDateString = (input: string) => {
    return input.replace(" ", "T").replace(" Z", "Z");
  };

  const dateObj = new Date(normalizeDateString(date));

  console.log("dateObj=", dateObj);

  // Only apply manual offset if no timezone is specified
  if (!timezone) {
    const timezoneOffset = dateObj.getTimezoneOffset() * 60000; // Convert to ms
    dateObj.setTime(dateObj.getTime() - timezoneOffset);        // Adjust to local time
  }

  const time = dateObj.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    ...(timezone && { timeZone: timezone })
  }).toLowerCase();

  const datePart = dateObj.toLocaleDateString('en-US', {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    ...(timezone && { timeZone: timezone })
  });

  return `${datePart} @ ${time}`;
};

export const date2usDotDate = (date: string) => {
      // Parse date string and treat as UTC to avoid timezone shifts
      const parts = date.split('-');
      if (parts.length === 3) {
        // YYYY-MM-DD format
        const month = parseInt(parts[1]);
        const day = parseInt(parts[2]);
        const year = parseInt(parts[0]);
        return `${month}.${day}.${year}`;
      }
      // Fallback to original behavior for other formats
      const dateObj = new Date(date);
      const datePart = dateObj.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' }).replace(/\//g, '.');
      return datePart;
}

export const utcDate = (date: string) => {
  const dateObj = new Date(date);
  return new Date(Date.UTC(
    dateObj.getUTCFullYear(),
    dateObj.getUTCMonth(),
    dateObj.getUTCDate(),
    dateObj.getUTCHours(),
    dateObj.getUTCMinutes()
  )).toISOString();
};

export const splitFirstAndLastName = (n: string) => {
  if (!n) {
    return ["", ""];
  }
  const re = /^([a-zA-Z]+)\s+([a-zA-Z ]+)$/;
  const cleanedName =  n
    .replace(/Doctor\s+/, "")
    .replace(/doctor\s+/, "")
    .replace(/,.*/, "");

  const result = cleanedName.match(re);
  if (result && result.length === 3) {
    return [result[1], result[2]];
  }
  return [cleanedName, ""];
}